module.exports = __webpack_public_path__ + "img/CS-ProfiNew_Overview-Rear_3.914dd62c.jpg";